import {
  InfoProvider,
  AuthService,
  AuthProvider,
  UserMode,
  HttpService,
} from "@sportal/api";

const allowedUserModes = [UserMode.SBSingle, UserMode.SBProfile];

export const makeAuthService = (
  http: HttpService,
  baseUrl: string
): AuthService =>
  new AuthService(
    new InfoProvider(http, baseUrl),
    new AuthProvider(http, baseUrl),
    allowedUserModes
  );
